"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasTypeOfClaim = void 0;
exports.hasTypeOfClaim = function (claim) { var _a; return ((_a = claim === null || claim === void 0 ? void 0 : claim.detail) === null || _a === void 0 ? void 0 : _a.typeOfClaim) != null; };
